import React from 'react';
import { PlayerData } from '../../types/player';
import { PlayerAnalysisSections } from './PlayerAnalysisSections';
import { ReferencedArticlesSection } from './ReferencedArticlesSection';
import { DebugSection } from './DebugSection';

interface PlayerAnalysisCardProps {
  playerData: PlayerData;
  showHistoricalSearchDialog: boolean;
}

export const PlayerAnalysisCard: React.FC<PlayerAnalysisCardProps> = ({
  playerData,
  showHistoricalSearchDialog
}) => {
  return (
    <div className="mt-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-[#CECFD2]">Player Analysis</h2>
      </div>
      
      <div className="mb-6 bg-[#121212] rounded-lg shadow-lg border border-gray-500 p-6">
      
      <PlayerAnalysisSections playerData={playerData} />
      
      <ReferencedArticlesSection playerData={playerData} />
      
      <DebugSection 
        playerData={playerData} 
        showHistoricalSearchDialog={showHistoricalSearchDialog} 
      />
      </div>
    </div>
  );
};